/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_Guide_ChooseInputs */

const en_google_drive_guide_choose = /** @type {(inputs: Google_Drive_Guide_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Choose in Google Drive`)
};

const es_google_drive_guide_choose = /** @type {(inputs: Google_Drive_Guide_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Elige en Google Drive`)
};

/**
* | output |
* | --- |
* | "1. Choose in Google Drive" |
*
* @param {Google_Drive_Guide_ChooseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_guide_choose = /** @type {((inputs?: Google_Drive_Guide_ChooseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_Guide_ChooseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_guide_choose(inputs)
	return en_google_drive_guide_choose(inputs)
});